var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiMlIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4.8,
    fill: "#F5222D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6571 14.5716C17.6571 11.4859 15.1268 9.42871 11.9999 9.42871C8.87306 9.42871 6.34277 11.4859 6.34277 14.5716V18.6859H17.6571V14.5716Z",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.42874V5.31445",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34277 15.6006H17.6571",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94287 15.6006V18.6863",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0571 15.6006V18.6863",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94275 13.5432C10.2268 13.5432 10.457 13.313 10.457 13.0289C10.457 12.7449 10.2268 12.5146 9.94275 12.5146C9.65872 12.5146 9.42847 12.7449 9.42847 13.0289C9.42847 13.313 9.65872 13.5432 9.94275 13.5432Z",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.057 13.5432C14.341 13.5432 14.5713 13.313 14.5713 13.0289C14.5713 12.7449 14.341 12.5146 14.057 12.5146C13.773 12.5146 13.5427 12.7449 13.5427 13.0289C13.5427 13.313 13.773 13.5432 14.057 13.5432Z",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMlIcon);
export default __webpack_public_path__ + "static/media/ai_ml_icon.086cfa29c7017a54a1d490b0bd86e6d2.svg";
export { ForwardRef as ReactComponent };